import React from 'react';

import { GraphQLProvider } from './src/context/GraphQLProvider';
import { AuthProvider } from './src/context/AuthProvider';
import { WishlistProvider } from './src/context/WishlistProvider';
import { CartProvider } from './src/context/CartProvider';
import { BindProvider } from './src/context/BindProvider';
import { setStorage, getStorage } from './src/helpers/general';
import { ReviewProvider } from './src/context/ReviewProvider';
import { FeatureFlagProvider } from './src/context/FeatureFlagProvider';
import { ChakraProvider } from '@chakra-ui/react';
import theme from './src/helpers/chakra/theme';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
require('dotenv').config();

const queryClient = new QueryClient();
export const onInitialClientRender = () => {
  if (typeof window.renderBadge === 'function') {
    try {
      window.renderBadge();
    } catch (err) {
      console.error(err);
    }
  }
};

export const wrapRootElement = ({ element }) => {
  return (
    <HelmetProvider>
      <GraphQLProvider bcPath={process.env.GATSBY_BC_PATH} domain={process.env.SITE_URL}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider bcPath={process.env.GATSBY_BC_PATH}>
            <ChakraProvider theme={theme} resetCSS={false}>
              <WishlistProvider>
                <ReviewProvider>
                  <CartProvider>
                    <BindProvider>
                      <FeatureFlagProvider>{element}</FeatureFlagProvider>
                    </BindProvider>
                  </CartProvider>
                </ReviewProvider>
              </WishlistProvider>
            </ChakraProvider>
          </AuthProvider>
        </QueryClientProvider>
      </GraphQLProvider>
    </HelmetProvider>
  );
};

const BOT_UA =
  /bot|crawl|spider|slurp|headless|lighthouse|render|gptbot|claudebot|bytespider|tiktokspider|baiduspider|adsbot|perplexity|amazonbot|petalbot|ahrefs|semrush|dataforseo|facebookexternalhit|phantomjs|puppeteer|playwright/i;

function isLikelyBot() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return true;
  if (navigator.webdriver) return true; // Catches headless automated scrapers
  if (BOT_UA.test(navigator.userAgent)) return true; // Catches all specific bot UAs case-insensitively
  if (!navigator.cookieEnabled) return true; // Prevents cookie-less single-hit MTU inflation
  return false;
}

export const onRouteUpdate = () => {
  if (!window.navigator.userAgent.includes('Googlebot') && !isLikelyBot()) {
    window.analytics && window.analytics.page();
  }
};

export const onClientEntry = () => {
  const maintenanceKey = getStorage('_fmk');
  if (
    process.env.SITE_MAINTENANCE === 'true' &&
    window.location.pathname !== '/maintenance' &&
    window.location.search.indexOf(process.env.GATSBY_MAINTENANCE_KEY) === -1 &&
    maintenanceKey !== process.env.GATSBY_MAINTENANCE_KEY
  ) {
    window.location = '/maintenance';
  } else if (window.location.search.indexOf(process.env.GATSBY_MAINTENANCE_KEY) > -1) {
    setStorage('_fmk', process.env.GATSBY_MAINTENANCE_KEY);
  }
};
